import { render } from "./RejectOutsideOrder.vue?vue&type=template&id=1b475a68"
import script from "./RejectOutsideOrder.vue?vue&type=script&lang=js"
export * from "./RejectOutsideOrder.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/dayungs_pos_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__